import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

class Datepicker extends React.Component {
  static propTypes = {
    date: PropTypes.any,
    fieldName: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    extraValues: PropTypes.any,
    showTimeSelect: PropTypes.bool,
    showYear: PropTypes.bool,
  };

  static defaultProps = {
    date: null,
    extraValues: null,
    showTimeSelect: false,
    showYear: false,
  };

  constructor(props) {
    super(props);
    let startDate = this.props.date;
    if (this.props.date !== null && moment(this.props.date).isValid()) {
      startDate = moment(this.props.date).toDate();
    } else {
      startDate = null;
    }
    this.state = {
      startDate,
    };
  }

  componentDidUpdate(prevProps) {
    // Check if the date has changed
    if (
      moment(this.props.date).isValid() &&
      !moment(this.props.date).isSame(prevProps.date)
    ) {
      this.setState({
        startDate: moment(this.props.date).toDate(),
      });
    }
  }

  onChangeRaw = (event) => {
    // Sets the field value so that yup validation can actually handle it and show an error if it is not a valid date
    this.props.setFieldValue(
      this.props.fieldName,
      moment(event.target.value),
      this.props.extraValues,
    );
    if (moment(event.target.value).isValid()) {
      this.setState({
        startDate: moment(event.target.value),
      });
    }
    return null;
  };

  handleChange = (date) => {
    // This ensures that the picked date is set as noon of the client's timezone.
    const safeDate = moment(date).isValid() ? date : null;

    // const dateAtNoon = setMomentTimeNoon(date, undefined, this.props.utcOffset);
    // console.devLog.info('Date at noon?', dateAtNoon);
    this.setState(
      {
        startDate: safeDate,
      },
      () => {
        this.props.setFieldValue(
          this.props.fieldName,
          moment(date),
          this.props.extraValues,
        );
      },
    );
  };

  render() {
    let dateFormatString = 'MMMM d';

    if (this.props.showYear) {
      dateFormatString = 'MMMM d, yyyy';
    }

    if (this.props.showTimeSelect) {
      dateFormatString = 'MMMM d h:mm aa';
    }

    return (
      <DatePicker
        selected={this.state.startDate}
        onChangeRaw={this.onChangeRaw}
        onChange={this.handleChange}
        placeholderText="Click to select a date"
        dateFormat={dateFormatString}
        {...this.props}
      />
    );
  }
}

export default Datepicker;
